export default "__VITE_ASSET__BCulrGz___"